<script lang="ts">
  import { defineComponent } from "vue";
  import FicheManualBillingDocuments from '@/generated/fiches/FicheManualBillingDocuments.vue';
  export default defineComponent({
    extends: FicheManualBillingDocuments,
    components: {}
})
</script>
